module.exports = __webpack_public_path__ + "img/tree.e5d8d9e0.svg";